<sm-input
  class="sm-search-control"
  [style.--sm-input-padding-start]="'2.7rem'"
  [style.--sm-input-padding-end]="inputPaddingEnd"
  [hasSideSlot]="true"
  [type]="'search'"
  [placeholder]="placeholder"
  [label]="label"
  [ariaLabel]="searchAriaLabel"
  [autocomplete]="'off'"
  [inputmode]="'search'"
  [disabled]="disabled"
  [autocapitalize]="'off'"
  [ngModel]="value"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="handleValueInput($event)"
  (compositionstart)="startComposition()"
  (compositionend)="endComposition($event)"
  (keydown.enter)="requestSearch($event)">

  @if (showSearchButton) {
    <button class="sm-search-control__leading sm-search-control__search-button" type="button"
      [disabled]="disabled" [attr.aria-label]="searchAriaLabel || null"
      (click)="requestSearch($event)">
      <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
    </button>
  } @else {
  <span class="sm-search-control__leading" aria-hidden="true">
    <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
  </span>
  }

  <div class="sm-search-control__actions">
    @if (showModeMenu && !disabled) {
      <sm-context-menu
        class="sm-search-control__mode-menu"
        [items]="resolvedModeItems"
        [triggerAriaLabel]="searchModeAriaLabel"
        [selectionStyle]="modeSelectionStyle"
        menuWidth="content"
        (itemSelect)="handleModeSelect($event)">
        <span smContextMenuTrigger class="sm-search-control__mode-trigger">
          <ion-icon name="options-outline" aria-hidden="true"></ion-icon>
        </span>
      </sm-context-menu>
    }

    @if (showScanner) {
    <button
      class="sm-search-control__scan-button"
      type="button"
      [disabled]="disabled"
      [attr.aria-label]="scanButtonLabel || null"
      [attr.title]="scanTitle || scanButtonLabel || null"
      (click)="handleScanClick()">
      <ion-icon [name]="scannedType === 'qr' ? 'qr-code-outline' : scannedType === 'barcode' ? 'barcode-outline' : 'scan-outline'" aria-hidden="true"></ion-icon>
    </button>
    }
  </div>
</sm-input>
